import React, { useState, useEffect } from "react";
import { noImage, prog1 } from "../../../assets";
import { useSelector, useDispatch } from "react-redux";
import { numberFormat } from "../../../helpers/numberFormat";
import { numberToDateString } from "../../../helpers/numberToDateString";
import { DetailProgramComp, DetailBundlingProgramComp } from "../..";
import Modal from "react-bootstrap/Modal";
import { MySwal } from "../../../lib/swal";
import "./style.css";

const CardProgramComp = (props) => {
  // console.log(props.bundlingPrograms)
  const [detailBundlingProgram, setDetailBundlingProgram] = useState(false);
  const [detailProgram, setDetailProgram] = useState(false);
  const [filterPrograms, setFilterPrograms] = useState(props.programs);
  const [filterBundlingPrograms, setfilterBundlingPrograms] = useState(
    props.bundlingPrograms
  );
  // const [bundlingPrograms, setBundlingPrograms] = useState(props.bundlingPrograms)
  const programs = props.programs;
  const bundlingPrograms = props.bundlingPrograms;
  const [typeOfProgram, settypeOfProgram] = useState("all");
  const [program, setProgram] = useState("");
  const [bundlingProgram, setbundlingProgram] = useState("");

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const dispatch = useDispatch();
  const bpSelected = useSelector((state) => state.bpSelected);
  const programSelected = useSelector((state) => state.programSelected);
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );

  const handleProgramSelected = (value) => {
    dispatch({ type: "SET_PROGRAM_SELECTED", payload: value });
    dispatch({ type: "SET_INPUT_ALERT", payload: false });
  };

  const handleBPSelected = (value) => {
    // console.log(value);
    dispatch({ type: "SET_BP_SELECTED", payload: value });
    dispatch({ type: "SET_INPUT_ALERT", payload: false });
  };

  const handleTambahProgram = () => {
    if (programSelected.length === 0 && bpSelected === 0) {
      MySwal.fire({
        icon: "warning",
        title: "Oops, Kesalahan!",
        text: "Anda belum memilih program.",
        confirmButtonColor: "#6e7d88",
      });
    } else {
      props.close();
    }
  };

  const handleDetailProgram = (e, program) => {
    e.preventDefault();
    setDetailProgram(true);
    setProgram(program);
  };

  const hanldeDetailBundlingProgram = (e, bp) => {
    e.preventDefault();
    setDetailBundlingProgram(true);
    setbundlingProgram(bp);
  };

  useEffect(() => {
    if (dataInputRegistration.searchProgram !== false) {
      const result = programs.filter((item) => {
        let name = item.name;
        return name
          .toLowerCase()
          .match(dataInputRegistration.searchProgram.toLowerCase());
      });
      setFilterPrograms(result);

      const resultBp = bundlingPrograms.filter((item) => {
        let name = item.name;
        return name
          .toLowerCase()
          .match(dataInputRegistration.searchProgram.toLowerCase());
      });
      setfilterBundlingPrograms(resultBp);
    }
    // eslint-disable-next-line
  }, [dataInputRegistration.searchProgram]);

  const handleFilterTypeProgram = (value) => {
    if (value === "all") {
      setfilterBundlingPrograms(props.bundlingPrograms);
      setFilterPrograms(props.programs);
      settypeOfProgram(value);
    } else {
      settypeOfProgram(value);
      let newFilterPrograms = props.programs.filter((p) => p.type === value);
      let newFilterBp = props.bundlingPrograms.filter((p) => p.type === value);
      setFilterPrograms(newFilterPrograms);
      setfilterBundlingPrograms(newFilterBp);
    }
  };

  const daftarProgram = [
    {
      nama: "Program A",
      deskripsi: "Deskripsi Program A",
      durasi: "6 bulan",
      biaya: "Rp 5.000.000",
      kategori: "Teknologi",
      schedule: [
        { tanggal: "2024-09-20", waktu: "10:00 - 12:00", tempat: "Ruang 101" },
        { tanggal: "2024-09-27", waktu: "10:00 - 12:00", tempat: "Ruang 102" },
      ],
    },
    {
      nama: "Program B",
      deskripsi: "Deskripsi Program B",
      durasi: "3 bulan",
      biaya: "Rp 2.500.000",
      kategori: "Bisnis",
      schedule: [
        { tanggal: "2024-09-18", waktu: "13:00 - 15:00", tempat: "Ruang 201" },
        { tanggal: "2024-09-25", waktu: "13:00 - 15:00", tempat: "Ruang 202" },
      ],
    },
    {
      nama: "Program C",
      deskripsi: "Deskripsi Program C",
      durasi: "12 bulan",
      biaya: "Rp 10.000.000",
      kategori: "Desain",
      schedule: [
        { tanggal: "2024-09-22", waktu: "09:00 - 11:00", tempat: "Ruang 301" },
        { tanggal: "2024-09-29", waktu: "09:00 - 11:00", tempat: "Ruang 302" },
      ],
    },
  ];

  // console.log(bundlingPrograms)

  return (
    <>
      <div className="d-flex justify-content-start mb-2 mt-1">
        <span
          onClick={() => handleFilterTypeProgram("all")}
          className={
            typeOfProgram === "all"
              ? "badge badge-pill bg-blue"
              : "badge badge-pill bg-green"
          }
          style={{ fontSize: "12px" }}
          type="button"
        >
          All
        </span>
        &nbsp;
        <span
          onClick={() => handleFilterTypeProgram("Online")}
          className={
            typeOfProgram === "Online"
              ? "badge badge-pill bg-blue"
              : "badge badge-pill bg-green"
          }
          style={{ fontSize: "12px" }}
          type="button"
        >
          Online
        </span>
        &nbsp;
        <span
          onClick={() => handleFilterTypeProgram("Offline")}
          className={
            typeOfProgram === "Offline"
              ? "badge badge-pill bg-blue"
              : "badge badge-pill bg-green"
          }
          style={{ fontSize: "12px" }}
          type="button"
        >
          Offline
        </span>
      </div>

      <div className="row overflow-auto border p-3" style={{ height: 450 }}>
        {filterBundlingPrograms?.map((bp, i) => (
          <div className="col-lg-4 col-md-6 col-12">
            <div
              type="button"
              className="card"
              style={{
                color: bpSelected.some((item) => bp.id === item.id)
                  ? "#FFFFFF"
                  : "",
                backgroundColor: bpSelected.some((item) => bp.id === item.id)
                  ? "#0C86D9"
                  : "#F2F2F2",
                borderRadius: "10px",
                // height: size.width < 500 ? '70vh' : '60vh',
                marginTop: "3%",
                filter: detailProgram === true ? "blur(8px)" : "",
              }}
            >
              <div className="checkbox-container m-3">
                <input
                  type="checkbox"
                  className="checkbox"
                  onClick={(e) => handleBPSelected(bp)}
                  checked={bpSelected.some((item) => bp.id === item.id)}
                />
                <h4 className="checkbox-label">Pilih Program</h4>
              </div>
              <img
                src={bp.coverLink || noImage}
                alt="prog1"
                width="100%"
                style={{
                  paddingLeft: "5%",
                  paddingRight: "5%",
                  paddingTop: "5%",
                }}
              />
              <div className="card-body">
                <div className="row">
                  <h4
                    style={{
                      color: bpSelected.some((item) => bp.id === item.id)
                        ? "#FFFFFF"
                        : "#0C86D9",
                      marginLeft: "13px",
                      fontSize: size.width < 500 ? "13px" : "15px",
                      fontWeight: "600",
                    }}
                  >
                    {bp.name}
                  </h4>
                </div>
                {size.width < 500 ? (
                  <div className="d-flex justify-content-between">
                    <div className="col-lg-7">
                      <h5
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontSize: size.width < 500 ? "13px" : "15px",
                        }}
                      >
                        Rp. {numberFormat(bp?.price)}
                      </h5>
                      <p
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontStyle: "italic",
                        }}
                      >
                        * belum termasuk PPN 12%
                      </p>
                    </div>
                    <div className="col-lg-5" style={{ textAlign: "right" }}>
                      <span
                        class="badge"
                        style={{ backgroundColor: "#26D07C", color: "#F2F2F2" }}
                      >
                        Available
                      </span>
                      &nbsp;
                      {bp.type === "Online" ? (
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#191919",
                            color: "#F2F2F2",
                          }}
                        >
                          Online
                        </span>
                      ) : (
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#191919",
                            color: "#F2F2F2",
                          }}
                        >
                          Offline
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div className="col-lg-6">
                      <h5
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                        }}
                      >
                        Rp. {numberFormat(bp?.price)}
                      </h5>
                      <p
                        style={{
                          color: bpSelected.some((item) => bp.id === item.id)
                            ? "#FFFFFF"
                            : "",
                          fontStyle: "italic",
                        }}
                      >
                        * belum termasuk PPN 12%
                      </p>
                    </div>
                    <div className="col-lg-6" style={{ textAlign: "right" }}>
                      <span
                        class="badge"
                        style={{ backgroundColor: "#26D07C", color: "#F2F2F2" }}
                      >
                        Available
                      </span>
                      &nbsp;
                      {bp.type === "Online" ? (
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#191919",
                            color: "#F2F2F2",
                          }}
                        >
                          Online
                        </span>
                      ) : (
                        <span
                          class="badge"
                          style={{
                            backgroundColor: "#191919",
                            color: "#F2F2F2",
                          }}
                        >
                          Offline
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {size.width < 500 ? (
                  ""
                ) : (
                  <div className="d-flex mt-3 mb-3">
                    <div className="col-6"></div>
                    <div
                      className="col-6 eli-color"
                      style={{ textAlign: "right" }}
                      onClick={(e) => hanldeDetailBundlingProgram(e, bp)}
                    >
                      <span style={{ fontSize: "14px" }}>
                        Detail Program&nbsp;
                        <i
                          style={{ fontSize: "14px", color: "black" }}
                          className="bi bi-arrow-right"
                        ></i>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}

        {filterPrograms.length > 0 ? (
          filterPrograms.map((program, index) =>
            program.Schedules.length > 0 ? (
              <div className="col-md-4 col-12 mb-4 d-flex" key={index}>
                {/* Card tanpa h-100 dan menggunakan flex-grow-1 */}
                <div
                  className="card flex-grow-1 d-flex flex-column"
                  style={{
                    color: programSelected.some(
                      (item) => program.id === item.id
                    )
                      ? "#FFFFFF"
                      : "",
                    backgroundColor: programSelected.some(
                      (item) => program.id === item.id
                    )
                      ? "#0C86D9"
                      : "#F2F2F2",
                    borderRadius: "10px",
                    // height: size.width < 500 ? '70vh' : '60vh',
                    marginTop: "3%",
                    filter: detailProgram === true ? "blur(8px)" : "",
                  }}
                >
                  <div className="card-body d-flex flex-column">
                    <div className="checkbox-container m-3">
                      <input
                        type="checkbox"
                        className="checkbox"
                        onClick={(e) => handleProgramSelected(program)}
                        checked={programSelected.some(
                          (item) => program.id === item.id
                        )}
                      />
                      <h4 className="checkbox-label">Pilih Program</h4>
                    </div>
                    <img
                      src={program.coverLink || noImage}
                      alt="prog1"
                      width="100%"
                      style={{
                        paddingLeft: "5%",
                        paddingRight: "5%",
                        paddingTop: "5%",
                      }}
                    />
                    <h4
                      style={{
                        color: programSelected.some(
                          (item) => program.id === item.id
                        )
                          ? "#FFFFFF"
                          : "#0C86D9",
                        marginLeft: "13px",
                        fontSize: size.width < 500 ? "13px" : "15px",
                        fontWeight: "600",
                      }}
                      className="card-title"
                    >
                      {program.name}
                    </h4>
                    <ul className="list-group list-group-flush mb-3">
                      {program.Schedules.map((schedule, j) => (
                        <li>
                          {numberToDateString(schedule.startDate)} s/d{" "}
                          {numberToDateString(schedule.endDate)}
                        </li>
                      ))}
                    </ul>
                    {size.width < 500 ? (
                      <div className="d-flex justify-content-between">
                        <div className="col-lg-12">
                          <h5
                            style={{
                              color: programSelected.some(
                                (item) => program.id === item.id
                              )
                                ? "#FFFFFF"
                                : "",
                              fontSize: size.width < 500 ? "13px" : "15px",
                            }}
                          >
                            Rp. {numberFormat(program?.Pricebooks[0].price)}
                          </h5>
                          <p
                            style={{
                              color: programSelected.some(
                                (item) => program.id === item.id
                              )
                                ? "#FFFFFF"
                                : "",
                              fontStyle: "italic",
                            }}
                          >
                            * belum termasuk PPN 12%
                          </p>
                        </div>
                        <div
                          className="col-lg-12"
                          style={{ textAlign: "right" }}
                        >
                          <span
                            class="badge"
                            style={{
                              backgroundColor: "#26D07C",
                              color: "#F2F2F2",
                            }}
                          >
                            Available
                          </span>

                          {program.type === "Online" ? (
                            <span
                              class="badge"
                              style={{
                                backgroundColor: "#191919",
                                color: "#F2F2F2",
                              }}
                            >
                              Online
                            </span>
                          ) : (
                            <span
                              class="badge"
                              style={{
                                backgroundColor: "#191919",
                                color: "#F2F2F2",
                              }}
                            >
                              Offline
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex">
                        <div className="col-lg-6">
                          <h5
                            style={{
                              color: programSelected.some(
                                (item) => program.id === item.id
                              )
                                ? "#FFFFFF"
                                : "",
                            }}
                          >
                            Rp. {numberFormat(program?.Pricebooks[0].price)}
                          </h5>
                          <p
                            style={{
                              color: programSelected.some(
                                (item) => program.id === item.id
                              )
                                ? "#FFFFFF"
                                : "",
                              fontStyle: "italic",
                            }}
                          >
                            * belum termasuk PPN 12%
                          </p>
                        </div>
                        <div
                          className="col-lg-6"
                          style={{ textAlign: "right" }}
                        >
                          <span
                            class="badge"
                            style={{
                              backgroundColor: "#26D07C",
                              color: "#F2F2F2",
                            }}
                          >
                            Available
                          </span>
                          &nbsp;
                          {program.type === "Online" ? (
                            <span
                              class="badge"
                              style={{
                                backgroundColor: "#191919",
                                color: "#F2F2F2",
                              }}
                            >
                              Online
                            </span>
                          ) : (
                            <span
                              class="badge"
                              style={{
                                backgroundColor: "#191919",
                                color: "#F2F2F2",
                              }}
                            >
                              Offline
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {size.width < 500 ? (
                      ""
                    ) : (
                      <div className="d-flex mt-3 mb-3">
                        <div className="col-6"></div>
                        <div
                          className="col-6 eli-color"
                          style={{ textAlign: "right" }}
                          onClick={(e) => handleDetailProgram(e, program)}
                        >
                          <span style={{ fontSize: "14px" }}>
                            Detail Program&nbsp;
                            <i
                              style={{ fontSize: "14px", color: "black" }}
                              className="bi bi-arrow-right"
                            ></i>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )
          )
        ) : props.programCategory === "3" ? (
          ""
        ) : (
          <div className="d-flex justify-content-center">
            <span className="badge bg-red">Belum ada Program!</span>
          </div>
        )}
      </div>

      {
        // jika bundling program
        props.programCategory === "3" ? (
          <>
            <div
              className="d-flex justify-content-end mt-3 mb-3"
              style={{ filter: detailProgram === true ? "blur(8px)" : "" }}
            >
              {size.width < 500 ? (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              ) : (
                <button
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              className="d-flex justify-content-end mt-3 mb-3"
              style={{ filter: detailProgram === true ? "blur(8px)" : "" }}
            >
              {size.width < 500 ? (
                <button
                  disabled={filterPrograms.length > 0 ? false : true}
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              ) : (
                <button
                  disabled={
                    filterPrograms.length > 0
                      ? false
                      : true && props.programCategory !== 3
                  }
                  style={{
                    fontSize: size.width < 500 ? "15px" : "20px",
                    fontWeight: "400",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  type="button"
                  className="btn btn-success"
                  onClick={handleTambahProgram}
                >
                  Tambah Program
                </button>
              )}
            </div>
          </>
        )
      }

      <Modal
        show={detailProgram}
        size="lg"
        onHide={() => setDetailProgram(false)}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <DetailProgramComp program={program} />
        </Modal.Body>
      </Modal>

      <Modal
        show={detailBundlingProgram}
        size="lg"
        onHide={() => setDetailBundlingProgram(false)}
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <DetailBundlingProgramComp bundlingProgram={bundlingProgram} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CardProgramComp;
